
    import '/mnt/src/components/CheckList/index.md?watch=parent';
    export const demoIndex = {
  ids: ["checklist-demo-single","checklist-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/CheckList/index.md?type=demo')
};